import { money } from './api';

type ContactBudget = {
  [key: string]: unknown;
  budgetKnown?: boolean;
  budgetMin?: number | null;
  budgetMax?: number | null;
};

/** Legacy contact fields use zero for an unstated bound. Explicit knownness takes precedence. */
export function contactBudgetLabel(contact: ContactBudget) {
  if (contact.budgetKnown === false) return 'Not provided';
  const bound = (value: unknown) =>
    typeof value === 'number' &&
    Number.isFinite(value) &&
    value >= 0 &&
    (value > 0 || contact.budgetKnown === true)
      ? value
      : null;
  const min = bound(contact.budgetMin),
    max = bound(contact.budgetMax);
  if (min === null && max === null) return 'Not provided';
  if (min === null) return `Up to ${money(max!)}`;
  if (max === null) return `From ${money(min)}`;
  return `${money(min)} – ${money(max)}`;
}
